import * as types from "../actions/globals.action";
const INITIAL_STATE = {
   loader: false,
   showInvite: {
      show: false,
      for: "",
   },
   showNorthwellError: false,
   emailGlobal: null,
   tokenGlobal: null,
   isUserFromMarketing: false,
   paymentInterval: false,
   referralCode: null,
};

export default function global(state = INITIAL_STATE, action) {
   switch (action.type) {
      case types.TOGGLE_LOADER:
         return {
            ...state,
            loader: !state.loader,
         };
      case types.TOGGLE_INVITE:
         return {
            ...state,
            showInvite: { show: !state.showInvite.show, for: action.payload },
         };

      case types.SHOW_NORTHWELL_ERROR:
         return {
            ...state,
            showNorthwellError: !state.showNorthwellError,
         };
      case types.SET_EMAIL_LOGIN:
         return {
            ...state,
            emailGlobal: action.payload,
         };
      case types.SET_SSO_TOKEN:
         return {
            ...state,
            tokenGlobal: action.payload,
         };
      case types.SET_IS_MARKETING:
         return {
            ...state,
            isUserFromMarketing: !state.isUserFromMarketing,
         };
      case types.SET_PAYMENT_INTERVAL:
         return {
            ...state,
            paymentInterval: true,
         };
      case types.SET_REFERRAL_CODE:
         return {
            ...state,
            referralCode: action.payload,
         };

      default:
         return state;
   }
}
